// extracted by mini-css-extract-plugin
export default {"header":"style--header--3703b0","right":"style--right--164d37","left":"style--left--497ef1","center":"style--center--b4340c"};